import { useCallback } from "react";
import useApi from "../../helpers/api";

export default function useActions() {
  const api = useApi();

  const validateCell = (field, value) => {
    if (!value) return `${field} No puede estar vacío.`;
    const validators = {
      titulo: /^.{1,45}$/,
      id_woo: /^[1-9]\d{0,4}$/,
      descripcion: /^.{1,245}$/,
    };

    if (field === "titulo" && !validators.titulo.test(value)) return "Titulo debe tener entre 1 y 45 caracteres.";
    if (field === "id_woo" && !validators.id_woo.test(value)) return "Id_woo debe ser un entero positivo menor a 100.000.";
    if (field === "descripcion" && !validators.descripcion.test(value)) return "Descripcion debe tener entre 1 y 245 caracteres.";
    return "";
  };

  const onCellEditingStopped = useCallback(async (event, gridRef) => {
    try {
      if (!gridRef.current) return;

      const rowData = event.data;
      const columns = ["id_woo", "titulo", "descripcion","template","tipo","bingo"];
      const colField = event.colDef.field;
      const errorMessage = validateCell(colField, event.newValue);
      const isNewRow = String(rowData.id).length >= 8;

      if (errorMessage) {
        rowData[`tooltipError${colField}`] = errorMessage;
        await gridRef.current.api.refreshCells({ rowNodes: [event.node], columns: [colField], force: true });

        rowData[colField] = event.oldValue;
        setTimeout(() => {
          gridRef.current.api.startEditingCell({
            rowIndex: event.node.rowIndex,
            colKey: colField,
          });
        }, 10);
        return;
      }

      rowData[`tooltipError${colField}`] = "";
      rowData[`isValid${colField}`] = true;
      gridRef.current.api.refreshCells({ force: true });

      setTimeout(() => {
        rowData[`isValid${colField}`] = false;
        gridRef.current.api.refreshCells({ force: true });
      }, 1000);

      if (isNewRow) {
        if (!rowData[colField]) {
          alert(`Field ${colField} cannot be empty.`);
          gridRef.current.api.applyTransaction({ remove: [rowData] });
          return;
        }

        const nextColIndex = columns.indexOf(colField) + 1;
        if (nextColIndex < columns.length) {
          setTimeout(() => {
            gridRef.current.api.startEditingCell({
              rowIndex: event.node.rowIndex,
              colKey: columns[nextColIndex],
            });
          }, 10);
        } else {
          if (rowData.id_woo && rowData.titulo && rowData.descripcion && !rowData.tooltipErrorid_woo && !rowData.tooltipErrortitulo && !rowData.tooltipErrordescripcion) {
            delete rowData.id;
            const newProducto = await api.createProducto(rowData);
            event.node.setData({ ...rowData, id: newProducto.id, createdAt: newProducto.createdAt });
          }
        }
      } else {
        if (event.newValue !== event.oldValue) {
          await api.updateProducto(rowData);
        }
      }
    } catch (error) {
      console.error("Error in onCellEditingStopped:", error);
    }
  }, [api]);

  const createHook = async (gridRef) => {
    if (!gridRef.current) return;

    const newRow = { id: Date.now(), id_woo: 10, titulo: "", descripcion: "", template: "1", tipo: "Platea", bingo: "No" };
    gridRef.current.api.applyTransaction({ add: [newRow] });

    setTimeout(() => {
      const rowNode = gridRef.current.api.getRowNode(newRow.id.toString());
      rowNode?.setSelected(true);
      gridRef.current.api.startEditingCell({
        rowIndex: gridRef.current.api.getDisplayedRowCount() - 1,
        colKey: "id_woo",
      });
    }, 10);
  };

  const handleDelete = (rowData, setSelectedRow,setModalOpen) => {
    setSelectedRow(rowData);
    setModalOpen(true);
  }

  const confirmDelete = async (gridRef, selectedRow, setModalOpen, setSelectedRow) => {
    if (!gridRef.current || !selectedRow) return;

    try {
      const response = await api.deleteProducto(selectedRow.data.id);
      if (response.status === 200) {
        gridRef.current.api.applyTransaction({ remove: [selectedRow.data] });
      }
    } catch (error) {
      console.error("Error deleting row:", error);
    } finally {
      setModalOpen(false);
      setSelectedRow(null);
    }
  };

  return { handleDelete, createHook, onCellEditingStopped, validateCell, confirmDelete };
}
